import React from 'react'
import "../css/LandingPage.css"
import { Button } from '@mui/material'
import { MdOutlineArrowForward } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { updateRole } from '../redux/actions';

function LandingPage(props) {

  const navigate = useNavigate()
  const { user, handleGuestLogin, handleRole } = props

  const handleGetStarted = () => {
    if (user) {
      navigate("/m2d")
    } else {
      navigate("/signin")
    }
  }

  const handleGuest = () => {
    handleGuestLogin()
    handleRole("Guest")
    navigate("/m2d")
  }

  return (
    <div className="lp-content">
      <div className="center-content">
        <div className="logo">ModelMeetsData</div>
        <div className="lp-description">
          A machine learning model hosting & testing plateform for researchers
        </div>
      </div>
      <div className="actions">
        <Button variant='outlined' size='large' sx={{marginRight: '15px'}} onClick={handleGetStarted}>Get Started <MdOutlineArrowForward style={{fontSize: '16px', marginLeft: '6px'}} /></Button>
        {user && user.Name !== "Guest User" ? null : (
          <Button variant='outlined' size='large' onClick={handleGuest}>Continue as guest <MdOutlineArrowForward style={{fontSize: '16px', marginLeft: '6px'}} /></Button>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleGuestLogin() {
      const action = {
        type: "LOGIN",
        user: {
          id: -1,
          firstName: "Guest",
          lastName: "User",
          username: "guestuser",
          email: "guest@guest.com",
          loginType: "local",
          isBot: 0,
          featureUsers: {
            2: {
              role: "Guest",
              app: "m2d"
            }
          }
        }
      }
      dispatch(action)
    },
    handleRole(role) {
      updateRole(role)
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
